import { selectErrorObject } from 'store/ui/activities';
import { useSelector } from 'hooks/utils';

export function useGetErrorByType(type: string, payload?: any) {
	return useSelector(state => selectErrorObject(state.ui.activities, { type, payload }));
}
